
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { RouterMeta } from '@/routing/config';

import { ReadyType } from '@/stores/ready.store';
import AppleBackdropExp from './AppleBackdropExp';
import ProPricingExp from './ProPricingExp';
import AppleQualityTvExp from './QualityTvExp';
import BypassUCTExp from './ByPassExp';
import CrunchyrollAsiaFreeTrialExp from './CrunchyrollAsiaFreeTrialExp';
const Ready = namespace('ready');

@Component({
	name: 'Experiments',
	components: {
		AppleBackdropExp,
		ProPricingExp,
		AppleQualityTvExp,
		BypassUCTExp,
		CrunchyrollAsiaFreeTrialExp,
	},
})
export default class Experiments extends Vue {
	@Ready.Mutation SET_READY: (readyType: ReadyType) => void;

	/**
	 * At Least Cache the routes with meta and tab
	 */
	get routeConfig() {
		return this.$router.options.routes?.filter(route => route?.meta?.tab);
	}

	mounted() {
		this.$nextTick().then(() => this.SET_READY(ReadyType.EXPERIMENTS_INIT));
	}

	routeNames(tab: RouterMeta['tab']) {
		return this.routeConfig?.filter(route => route?.meta?.tab === tab);
	}

	tab(tab: RouterMeta['tab']) {
		return this.routeNames(tab)?.map(route => route.name);
	}
}
